"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.Title = exports.Section = exports.Root = exports.Overlay = exports.LineLoading = exports.Inner = exports.Header = exports.Buttons = exports.Block = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _animations = require("../styles/animations");
var _responsive = require("../styles/responsive");
var _common = require("../styles/common");
var _Line = require("../../lib/Loading/Line");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const innerPadding = '15px';
const animationDuration = '0.3s';
const Root = _styledComponents.default.div`
    position: fixed;
    z-index: 1300;
    
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    animation: ${_animations.fadeIn} ${animationDuration};
`;
exports.Root = Root;
const Overlay = _styledComponents.default.div`
    background-color: rgba(var(--black-rgb), 0.2);

    height: 100%;
    width: 100%;

    display: flex;
    align-items: center;
    justify-content: center;
`;
exports.Overlay = Overlay;
const Wrapper = _styledComponents.default.div`
    ${(0, _responsive.respondTo)('phone', (0, _styledComponents.css)`
        max-height: 100%;
        height: 100%;
        width: 100%;
        margin: 0;
        border-radius: 0;
        animation: none;
    `)}

    width: ${({
  size
}) => {
  switch (size) {
    case 'lg':
      return '700px;';
    case 'md':
      return '600px;';
    case 'sm':
      return '540px;';
    case 'xs':
      return '360px;';
    default:
      return size;
  }
}};

    display: flex;
    flex-direction: column;
    
    max-height: calc(100% - 64px);
    margin: 32px;

    background-color: var(--bg-color);
    border-radius: 7px;
    border: 1px solid var(--border-color);

    box-shadow: 0 3px 6px rgba(black, 0.3);

    position: relative;
    overflow-y: auto;

    animation: ${_animations.animateZoom} ${animationDuration};
`;
exports.Wrapper = Wrapper;
const Header = _styledComponents.default.div`
    // From MUI
    flex: 0 0 auto;
    padding: 0 ${innerPadding};

    // VCS
    display: flex;
    align-items: center;
    height: 50px;
    color: var(--text-primary-color);
    border-bottom: ${({
  borderBottom
}) => borderBottom ? '1px solid var(--border-color)' : 'none'};

    // Because of loading
    position: relative;
`;
exports.Header = Header;
const LineLoading = (0, _styledComponents.default)(_Line.Line)`
    position: absolute;
    left: 0;
    right: 0;
    bottom: -1px;
`;
exports.LineLoading = LineLoading;
const Title = _styledComponents.default.div`
    max-width: 92%;
    ${_common.textOverflow};

    font-size: 14px;
    text-transform: uppercase;
    font-weight: bold;
`;
exports.Title = Title;
const Inner = _styledComponents.default.div`
    flex: 1 1 auto;
    overflow-y: auto;
`;
exports.Inner = Inner;
const Section = _styledComponents.default.div`
    padding: 0 ${innerPadding};
`;
exports.Section = Section;
const Buttons = _styledComponents.default.div`
    flex: 0 0 auto;
    display: flex;
    padding: ${innerPadding};
    align-items: center;
    justify-content: space-between;
    flex-direction: row-reverse;

    button {
        min-width: 120px;
    }
`;
exports.Buttons = Buttons;
const Block = _styledComponents.default.div`
    padding: 0 ${innerPadding};
    margin: ${innerPadding} 0;
`;
exports.Block = Block;